export default {
    oneIdModal: {
        containerView: {
            emailForm: {
                containerKey: 'email_capture',
                containerType: 'form',
                elements: [{
                    elementId: 'sign_up',
                    elementIdType: 'button',
                    elementIndex: 0,
                    mediaFormatType: 'not_applicable'
                }],
                elementsPerWidth: 1,
                horizontalPosition: 0,
                verticalPosition: 0
            }
        },
        interaction: {
            signUp: {
                containerKey: 'email_capture',
                containerType: 'form',
                elementId: 'sign_up',
                elementIdType: 'button',
                elementName: 'sign_up',
                elementType: 'button',
                interactionType: 'select'
            }
        },
        pageView: {
            pageId: 'sign_up_for_updates',
            pageName: 'sign_up_for_updates',
            pageKey: 'sign_up_for_updates'
        }
    }
};
